import {alert, alertDismiss} from './alert';
import _t from './translations';

export default () => {
    const qs = (selector) => document.querySelector(selector);
    const domainBuyForm = qs('#domainBuyForm');
    const domainBuyInput = qs('#domainBuyInput');
    const checkPriceBtn = qs('#checkPriceBtn');
    const actuallyBuyBtn = qs('#actuallyBuyBtn');

    if (!domainBuyForm) {
        return;
    }

    //disable enter so user is forced to click specific buttons
    domainBuyForm.addEventListener('keypress', function(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    });

    domainBuyInput.addEventListener("input", function(event) {
        checkPriceBtn.classList.remove('d-none');
        actuallyBuyBtn.classList.add('d-none');
        checkPriceBtn.classList.add('d-flex');
    });

    actuallyBuyBtn.addEventListener("click", function(event) {
        console.log('actually buy clicked!');
        console.log(domainBuyForm);
        domainBuyForm.submit();
    });

    checkPriceBtn.addEventListener("click", function(event) {
        event.preventDefault();

        if (!domainBuyInput.checkValidity()) {
            domainBuyInput.reportValidity();

            return false;
        }

        const lng = qs('html').getAttribute('lang') ?? 'en';
        const domainInfoUrl = '/' + lng + '/registrar/' + domainBuyInput.value;

        checkPriceBtn.disabled = true;

        //checkPriceBtn.textContent = _t('buy.check_btn.progress')
        let dotCount = 3;
        const progressInterval = setInterval(() => {
            dotCount = (dotCount % 3) + 1;
            checkPriceBtn.textContent = '.'.repeat(dotCount);
        }, 500);

        async function getDomainInfo(apiUrl) {
            const response = await fetch(apiUrl, {
                credentials: "include",
                method: "GET"
            });

            return response.json();
        }

        getDomainInfo(domainInfoUrl)
            .then((data) => {
                // console.log({
                //     data
                // });
                alertDismiss('#domainBuyMessage');
                //show info about domain price
                if (data['available']) {

                    const checkCircle = `
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                            <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                        </svg>
                    `;

                    const message = `
                        <div class="d-flex flex-row text-start flex-fill">
                            <svg class="me-3" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.9375 0C17.5987 0 13.3573 1.28661 9.74969 3.69714C6.14209 6.10766 3.3303 9.53383 1.6699 13.5424C0.00950518 17.5509 -0.424931 21.9618 0.421533 26.2173C1.268 30.4728 3.35734 34.3817 6.42536 37.4497C9.49337 40.5177 13.4023 42.607 17.6577 43.4535C21.9132 44.3 26.3241 43.8655 30.3326 42.2051C34.3412 40.5447 37.7674 37.7329 40.1779 34.1253C42.5884 30.5177 43.875 26.2763 43.875 21.9375C43.8689 16.1212 41.5556 10.5449 37.4429 6.43213C33.3301 2.31938 27.7538 0.00614212 21.9375 0ZM31.5689 18.0689L19.7564 29.8814C19.5997 30.0383 19.4136 30.1628 19.2087 30.2477C19.0039 30.3326 18.7843 30.3763 18.5625 30.3763C18.3408 30.3763 18.1212 30.3326 17.9163 30.2477C17.7114 30.1628 17.5253 30.0383 17.3686 29.8814L12.3061 24.8189C11.9895 24.5023 11.8116 24.0728 11.8116 23.625C11.8116 23.1772 11.9895 22.7477 12.3061 22.4311C12.6227 22.1145 13.0522 21.9366 13.5 21.9366C13.9478 21.9366 14.3773 22.1145 14.6939 22.4311L18.5625 26.3018L29.1811 15.6811C29.3379 15.5243 29.524 15.3999 29.7289 15.3151C29.9337 15.2302 30.1533 15.1866 30.375 15.1866C30.5967 15.1866 30.8163 15.2302 31.0212 15.3151C31.226 15.3999 31.4121 15.5243 31.5689 15.6811C31.7257 15.8379 31.8501 16.024 31.9349 16.2289C32.0198 16.4337 32.0635 16.6533 32.0635 16.875C32.0635 17.0967 32.0198 17.3163 31.9349 17.5211C31.8501 17.726 31.7257 17.9121 31.5689 18.0689Z" fill="#3CBB3A"/>
                            </svg>
                            <div class="d-flex flex-column alert-rich-body">
                                <h3>${_t('buy.domain.great_news')}</h3>
                                <p>${domainBuyInput.value} ${_t('buy.domain.available')}</p>
                                <ul class="list-unstyled">
                                    <li class="py-1"><span class="text-success">${checkCircle}</span> ${_t('buy.domain.feat_own')}</li>
                                    <li class="py-1"><span class="text-success">${checkCircle}</span> 3 ${_t('buy.domain.feat_mailboxes_included')}</li>
                                    <li class="py-1"><span class="text-success">${checkCircle}</span> ${_t('buy.domain.feat_premium_subscription')}</li>
                                </ul>
                            </div>
                            <span class="fs-5 fw-medium flex-fill text-end">
                                ${data['currency']} ${Number.parseFloat(data['fee']).toFixed(2)}
                            </span>
                        </div>
                    `;

                    alert(
                        'success',
                        message,
                        false,
                        '#domainBuyMessage',
                        true,
                        false
                    );

                    checkPriceBtn.classList.add('d-none');
                    actuallyBuyBtn.classList.remove('d-none');
                } else {

                    let errMsg = _t('buy.domain.not_available');
                    if (data['error'] && data['error'] === 'DomainFormatException') {
                        errMsg = _t('buy.domain.invalid')
                    }

                    const message = `
                        <div class="d-flex flex-row text-start">
                            <svg class="me-3" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.9375 0C17.5987 0 13.3573 1.28661 9.74969 3.69714C6.14209 6.10766 3.3303 9.53383 1.6699 13.5424C0.00950518 17.5509 -0.424931 21.9618 0.421533 26.2173C1.268 30.4728 3.35734 34.3817 6.42536 37.4497C9.49337 40.5177 13.4023 42.607 17.6577 43.4535C21.9132 44.3 26.3241 43.8655 30.3326 42.2051C34.3412 40.5447 37.7674 37.7329 40.1779 34.1253C42.5884 30.5177 43.875 26.2763 43.875 21.9375C43.8689 16.1212 41.5556 10.5449 37.4429 6.43213C33.3301 2.31938 27.7538 0.00614212 21.9375 0ZM20.25 11.8125C20.25 11.365 20.4278 10.9357 20.7443 10.6193C21.0607 10.3028 21.49 10.125 21.9375 10.125C22.3851 10.125 22.8143 10.3028 23.1308 10.6193C23.4472 10.9357 23.625 11.365 23.625 11.8125V23.625C23.625 24.0726 23.4472 24.5018 23.1308 24.8183C22.8143 25.1347 22.3851 25.3125 21.9375 25.3125C21.49 25.3125 21.0607 25.1347 20.7443 24.8183C20.4278 24.5018 20.25 24.0726 20.25 23.625V11.8125ZM21.9375 33.75C21.4369 33.75 20.9475 33.6016 20.5312 33.3234C20.115 33.0453 19.7905 32.65 19.5989 32.1874C19.4074 31.7249 19.3572 31.216 19.4549 30.7249C19.5526 30.2339 19.7936 29.7829 20.1477 29.4289C20.5017 29.0749 20.9527 28.8338 21.4437 28.7361C21.9347 28.6385 22.4437 28.6886 22.9062 28.8802C23.3687 29.0718 23.764 29.3962 24.0422 29.8125C24.3203 30.2287 24.4688 30.7181 24.4688 31.2188C24.4688 31.8901 24.2021 32.5339 23.7274 33.0086C23.2527 33.4833 22.6088 33.75 21.9375 33.75Z" fill="#ED3309"/>
                            </svg>
                            <div class="d-flex flex-column">
                                <h3>${_t('buy.domain.sorry')}</h3>
                                <p>${domainBuyInput.value} ${errMsg}</p>
                                <p style="color: #444444;">${_t('buy.domain.try_different')}</p>
                            </div>
                        </div>
                    `;

                    alert('danger', message, false, '#domainBuyMessage', true, false);
                    actuallyBuyBtn.classList.add('d-none');
                }
            })
            .catch((error) => {
                // console.error({
                //     error
                // });
                alert('danger', _t('buy.domain.can_not_get_info') + ' ' + _t('error') + ': ' + error, true, '#domainBuyMessage');
            })
            .finally(() => {
                clearInterval(progressInterval);
                checkPriceBtn.textContent = _t('buy.check_btn.initial')
                checkPriceBtn.disabled = false;
            });
    });
};
